import { InputType } from 'config'

export const defaultInputs = (): Record<string, InputType> => {
  let rtl: Record<string, InputType> = {
    closingDocumentDate: {
      inputType: 'text',
      type: 'date',
      title: 'Closing / Document Date',
      required: true,
    },
    custom1: {
      inputType: 'custom',
      title: 'custom1',
    },
    preparerName: {
      inputType: 'text',
      title: 'Preparer Name',
    },
    preparerEmail: {
      inputType: 'text',
      type: 'email',
      title: 'Preparer Email',
    },
    preparerAddress: {
      inputType: 'map',
      title: 'Preparer Address',
    },
    interestType: {
      title: 'Interest Type',
      inputType: 'select',
      hasDefaultOption: true,
      options: ['Dutch', 'Non Dutch'],
      required: true,
      history: false,
    },
    titleDate: {
      inputType: 'text',
      type: 'date',
      title: 'Title date',
      required: true,
    },
    titleAccountNumber: {
      inputType: 'text',
      type: 'text',
      title: 'Title Account Number',
      value: '',
      required: true,
    },
    lienPosition: {
      inputType: 'select',
      title: 'Lien Position',
      options: ['First', 'Second', 'Third'],
      hasDefaultOption: true,
      required: true,
      disabled: true,
    },
    apnNumber: {
      inputType: 'text',
      title: 'Parcel No',
      required: true,
      disabled: true,
    },
    escrowType: {
      title: 'Escrow Type',
      inputType: 'select',
      hasDefaultOption: true,
      options: ['Not Waived', 'Waive All', 'Waive Taxes', 'Waive Insurance', 'Waive Taxes and Insurance'],
      required: true,
    },
    prepayment: {
      inputType: 'select',
      title: 'Prepayment',
      required: true,
      hasDefaultOption: true,
      options: {},
    },
    personalGuaranty: {
      inputType: 'select',
      title: 'Personal Guaranty',
      options: ['Full Recourse', 'Non Recourse', 'Non Recourse with Bad Boy carveouts'],
      hasDefaultOption: true,
      required: true,
    },
    defaultRate: {
      inputType: 'text',
      type: 'number',
      prefix: '%',
      title: 'Default Rate',
      required: true,
    },
    enableExtension: {
      inputType: 'toggle',
      title: 'Enable Extension',
      value: false,
    },
    custom2: {
      inputType: 'custom',
      title: 'custom2',
    },
    numberOfExtensions: {
      inputType: 'text',
      type: 'number',
      title: 'Number of Allowable Extensions',
      required: true,
    },
    extensionFeePerc: {
      inputType: 'text',
      type: 'text',
      title: 'Extension Fee Percent',
      value: '',
      prefix: '%',
      required: true,
    },
    IncrementOfExtensions: {
      inputType: 'text',
      type: 'number',
      title: 'Increment of Extensions',
      required: true,
    },
    exceptions: {
      inputType: 'textarea',
      title: 'Exceptions to be removed',
      span: 'full',
      rows: 10,
    },
  }

  return rtl
}
